import { useQuery } from '@tanstack/react-query';
import { ArrowLeft, Hash, TrendingUp } from 'lucide-react';
import { hashtagsApi } from '@/api/hashtags';

/**
 * Список сторис по хештегу + список трендовых тегов.
 */
export default function HashtagView({
  tag,
  onBack,
  onOpenTag,
}: {
  tag: string | null;
  onBack: () => void;
  onOpenTag: (tag: string) => void;
}) {
  const { data: trending } = useQuery({
    queryKey: ['hashtags', 'trending'],
    queryFn: () => hashtagsApi.trending(30),
    enabled: !tag,
  });

  const { data: byTag } = useQuery({
    queryKey: ['hashtags', tag],
    queryFn: () => hashtagsApi.byTag(tag!),
    enabled: !!tag,
  });

  if (!tag) {
    return (
      <div className="h-full flex flex-col bg-surface-950 text-white">
        <div className="flex items-center gap-3 p-4 border-b border-surface-800">
          <button onClick={onBack}><ArrowLeft size={20} /></button>
          <div className="flex items-center gap-2">
            <TrendingUp size={18} />
            <span className="font-semibold">Тренды</span>
          </div>
        </div>
        <div className="flex-1 overflow-y-auto">
          {(trending ?? []).map((h) => (
            <button
              key={h.id}
              onClick={() => onOpenTag(h.tag)}
              className="w-full flex items-center gap-3 px-4 py-3 border-b border-surface-800 hover:bg-surface-900 text-left"
            >
              <div className="w-9 h-9 rounded-full bg-surface-800 flex items-center justify-center">
                <Hash size={16} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-medium">#{h.tag}</div>
                <div className="text-xs text-surface-400">{h.count ?? h.storyCount} сторис</div>
              </div>
            </button>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="h-full flex flex-col bg-surface-950 text-white">
      <div className="flex items-center gap-3 p-4 border-b border-surface-800">
        <button onClick={onBack}><ArrowLeft size={20} /></button>
        <Hash size={18} />
        <span className="font-semibold">{tag}</span>
        <span className="ml-auto text-xs text-surface-400">{byTag?.storyCount ?? 0}</span>
      </div>
      <div className="flex-1 overflow-y-auto grid grid-cols-3 gap-1 p-1">
        {(byTag?.stories as { id: string; mediaFile: { id: string }; author: { displayName: string } }[] | undefined)?.map(
          (s) => (
            <div key={s.id} className="aspect-[9/16] bg-surface-800 relative overflow-hidden">
              <img
                src={`/api/media/${s.mediaFile.id}/thumbnail`}
                alt=""
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute bottom-1 left-1 text-xs bg-black/60 px-1 rounded">
                {s.author.displayName}
              </div>
            </div>
          ),
        )}
      </div>
    </div>
  );
}
